<script>
import AdminLayout from '@layouts/admin-main'
import CertificationList from '@components/admin/kyc-asset-withdraw-address-certification-list'

export default {
  page: {
    title: 'Admin::KycAssetWithdrawAddressCertificationList',
    meta: [
      {
        name: 'description',
        content: 'Admin::KycAssetWithdrawAddressCertificationList',
      },
    ],
  },
  components: { AdminLayout, CertificationList },
}
</script>

<template>
  <AdminLayout>
    <CertificationList></CertificationList>
  </AdminLayout>
</template>
